import type { Team, User } from '../types';

type TeamPermissionUser = Pick<User, 'id' | 'iscoach' | 'role'>;
type TeamPermissionTeam = Pick<Team, 'coach'>;

/** Player statistics are a coach tool bounded to the active team. */
export const canAccessTeamPlayerStatistics = (
  user: TeamPermissionUser | null | undefined,
  team: TeamPermissionTeam | null | undefined
): boolean => {
  if (!user || !team) return false;
  if (user.role === 'admin' || user.role === 'club-manager') return true;
  if (user.iscoach) return true;

  return team.coach.some((coach) => coach.id === user.id);
};
